import React, { useCallback, useEffect, useState } from "react";
import TileCustomHeading from "../TileCustomHeading";
import OuterDraggable from "react-draggable";

const HeadingConfig = ({ onSave, viewOnly, onCancel, currentData, headingName = "" }) => {
    const [heading, setHeading] = useState({ table_main: true });
    const [isCustomTypeHeading, setIsCustomTypeHeading] = useState({ table_main: false });
    const [headingStyleData, setHeadingStyleData] = useState({
        table_main: {
            name: "",
            bold: false,
            color: "ffffff",
            font_size: 10,
            font_id: "",
            bg_color: "003f2d",
            alignment: "left",
            cell_margin: { top: 0.04, left: 0.04, right: 0.04, bottom: 0.04 },
            heading_style: "Heading 3"
        }
    });
    const [error, setError] = useState({});
    const [transform, setTransform] = useState({ left: 0, top: 0 });

    function omitKeys(obj, keys) {
        return Object.fromEntries(Object.entries(obj).filter(([k]) => !keys.includes(k)));
    }
    const checkObjectKeyPresent = obj => {
        return obj && Object.keys(obj)?.length > 0 ? true : false;
    };

    useEffect(() => {
        if (currentData) {
            const userTableMainConfig = currentData?.table_heading || null;
            const finalTableMain = {
                ...headingStyleData.table_main,
                ...(userTableMainConfig?.custom_heading_props || {}),

                name: userTableMainConfig?.name || headingName || "",
                heading_style: userTableMainConfig?.structured_heading?.heading_style ?? "Heading 3"
            };
            setHeading({
                table_main: !!userTableMainConfig
            });
            setHeadingStyleData(prev => ({
                ...prev,
                table_main: finalTableMain
            }));
            setIsCustomTypeHeading({
                table_main: checkObjectKeyPresent(userTableMainConfig?.custom_heading_props)
            });
        }
    }, [currentData]);

    const getHeadingData = view => {
        const data = headingStyleData[view];
        const isCustom = isCustomTypeHeading[view];
        if (!data?.name?.trim()) return null;

        return {
            name: data.name,
            ...(isCustom
                ? { custom_heading_props: omitKeys(data, ["name", "heading_style"]) }
                : { structured_heading: { heading_style: data.heading_style } })
        };
    };

    const handleClickSave = () => {
        const tableHeadingData = getHeadingData("table_main");

        const validationErrors = {
            table_main: heading.table_main && !tableHeadingData
        };

        setError(validationErrors);

        const isValid = !Object.values(validationErrors).some(Boolean);
        if (!isValid) return;

        onSave({
            ...(heading.table_main && tableHeadingData ? { table_heading: tableHeadingData } : {})
        });
    };
    const handleTransform = useCallback((e, ui) => setTransform({ left: ui.x, top: ui.y }), []);
    return (
        <div
            className="modal modal-region modal-view reco-view-mdl column-setting-modal smart-chart-popup bbi-popup-mod bbi-dynamic-config-modal"
            style={{ display: "block" }}
            tabIndex="-1"
        >
            <div className="modal-dialog" role="document">
                <OuterDraggable handle=".draggable" cancel=".not-draggable" onDrag={handleTransform}>
                    <div className="modal-content outerModal_draggable" style={transform}>
                        <div className="modal-header draggable">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <div className="txt-hed d-flex align-items-center">Configure</div>
                                <div className="sys-wrap">
                                    <div className="config-top-rgt-cont"></div>
                                </div>
                            </h5>
                            <button type="button" className="close" onClick={() => onCancel()}>
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body region-otr">
                            <div className="col-md-12 sm-chart-views pl-1 not-draggable">
                                <div className="fot-sec top-border types-otr-chart-sec overflw-scrl">
                                    <div className="fot-select">
                                        <label>Table Heading</label>
                                        <div className="check-box-area">
                                            <label className={`container-check ${viewOnly ? "cursor-diabled" : ""} green-check`}>
                                                Yes
                                                <input
                                                    type="checkbox"
                                                    checked={heading.table_main}
                                                    onClick={() => setHeading({ ...heading, table_main: true })}
                                                    disabled={viewOnly}
                                                />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className="check-box-area">
                                            <label className={`container-check ${viewOnly ? "cursor-diabled" : ""} green-check`}>
                                                No
                                                <input
                                                    type="checkbox"
                                                    checked={!heading.table_main}
                                                    onClick={() => setHeading({ ...heading, table_main: false })}
                                                    disabled={viewOnly}
                                                />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>

                                    {heading.table_main && (
                                        <>
                                            <div className="fot-select">
                                                <label>Heading Type</label>
                                                <div className="check-box-area">
                                                    <label className={`container-check ${viewOnly ? "cursor-diabled" : ""} green-check`}>
                                                        Custom Heading
                                                        <input
                                                            type="checkbox"
                                                            checked={isCustomTypeHeading.table_main}
                                                            onClick={() => setIsCustomTypeHeading({ ...isCustomTypeHeading, table_main: true })}
                                                            disabled={viewOnly}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </div>
                                                <div className="check-box-area">
                                                    <label className={`container-check ${viewOnly ? "cursor-diabled" : ""} green-check`}>
                                                        Predefined Heading
                                                        <input
                                                            type="checkbox"
                                                            checked={!isCustomTypeHeading.table_main}
                                                            onClick={() => setIsCustomTypeHeading({ ...isCustomTypeHeading, table_main: false })}
                                                            disabled={viewOnly}
                                                        />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="card p-0 mb-2 single-col-form">
                                                <div className="card-header">
                                                    <div
                                                        className="d-flex content-block-2 otr-recom-div no-bottom-bord btn"
                                                        data-toggle="collapse"
                                                        data-target="#collapseTable"
                                                    >
                                                        <button className="btn heading-btn-accordion">Heading Styles</button>
                                                    </div>
                                                </div>
                                                <div id="collapseTable" className="collapse show">
                                                    <div className="card-body p-0 pt-2">
                                                        <TileCustomHeading
                                                            setHeadingStyleData={setHeadingStyleData}
                                                            chartView="table_main"
                                                            headingStyleData={headingStyleData}
                                                            isCustomTypeHeading={isCustomTypeHeading}
                                                            error={error}
                                                            viewOnly={viewOnly}
                                                            className={isCustomTypeHeading.table_main ? "custom-padding" : ""}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 p-0 mt-4 text-right btnOtr d-flex">
                            <div className="tot-btr">
                                <button type="button" onClick={onCancel} className="btn btn-secondary btnClr col-md-3 mr-1">
                                    Cancel
                                </button>
                                {!viewOnly && (
                                    <button type="button" onClick={handleClickSave} className="btn btn-primary btnRgion btn-wid">
                                        Save
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </OuterDraggable>
            </div>
        </div>
    );
};

export default HeadingConfig;
